import React from 'react';
import PropTypes from 'prop-types';
import { PrsButton } from '../../../styles-and-themes/styles/prsButtons';

import { CompletionHeader, CompletionHeaderLarge } from './RegistrationCompletePanelStyles';

const RegistrationCompletePanel = ({
  email, isPriorRegistration, isEmailVerified, onGoToLogin,
}) => {
  const getHeaderContent = () => {
    if (isPriorRegistration) return (<CompletionHeader>This account already exists.</CompletionHeader>);
    if (isEmailVerified) return (<CompletionHeader>Your registration is complete!</CompletionHeader>);
    return (<CompletionHeaderLarge>Check Your Email to Continue Registration</CompletionHeaderLarge>);
  };

  const getBodyContent = () => {
    // 1. User just complete registration and email already verified
    if (isEmailVerified) {
      return (
        <>
          <p>
            Return to the Sign In page to access your account and products.
          </p>
          <div style={{ marginTop: '20px' }}>
            <PrsButton onClick={onGoToLogin}>
              Sign In
            </PrsButton>
          </div>
        </>
      );
    }

    // 2. user was done before they got here - just go to login
    if (isPriorRegistration) {
      return (
        <p>
          Your account has already been created. Please sign in to your account to continue.
        </p>
      );
    }

    // 3. User just completed registartion but still needs to verify email
    return (
      <p>
        An email has been sent to { email }. Click the button in the email{' '}
        to confirm your email address and resume your account registration.
      </p>
    );
  };

  return (
    <>
      {getHeaderContent()}
      {getBodyContent()}
    </>
  );
};

RegistrationCompletePanel.propTypes = {
  email: PropTypes.string.isRequired,
  isEmailVerified: PropTypes.bool.isRequired,
  isPriorRegistration: PropTypes.bool.isRequired,
  onGoToLogin: PropTypes.func,
};

RegistrationCompletePanel.defaultProps = {
  onGoToLogin: () => {},
};

export default RegistrationCompletePanel;
